(function () {

    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.campaignpage = window.oneadvanced.campaignpage || {};
    window.oneadvanced.campaignpage.init = function () {
        //console.log("initialising campaignpage...");
        var campaignPage = document.querySelectorAll('[data-cam-page-id]');
        if (campaignPage.length) {
            for (var si = 0; si < campaignPage.length; si++) {
                $(window).scroll(function () {
                    $(".jumbotronblock header.cell").css("opacity", 1 - $(window).scrollTop() / ($(".jumbotronblock").height()/2));
                });
            }
        }
    };
    window.oneadvanced.campaignpage.hasLoaded = true;
}) ();